<template>
  <div class="dev-filter-form custom-wrapper">
    <!--表格查询表单-->
    <div class="filter-wrapper" >
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">
        <el-form-item label="设备号" prop="sn">
          <el-input
            v-model="filterForm.sn"
            placeholder="请输入设备号"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>
        <el-form-item label="IMEI号" prop="clientid">
          <el-input
            v-model="filterForm.clientid"
            placeholder="请输入设备 IMEI 号"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="title">
          <el-input
            v-model="filterForm.title"
            placeholder="请输入设备名称"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>
        <el-form-item label="mac" prop="mac_id">
          <el-input
            v-model="filterForm.mac_id"
            placeholder="请输入设备 mac地址"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>
        <el-form-item label="ICCID" prop="iccid">
          <el-input
            v-model="filterForm.iccid"
            placeholder="请输入设备物联卡号ICCID"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>
        <el-form-item label="应用号" prop="app_code">
          <el-input
            v-model="filterForm.app_code"
            placeholder="请输入设备应用号"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="type">
          <el-select v-model="filterForm.type" placeholder="请选择设备类型" style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option label="线上商城" value="osm"></el-option>
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在线状态" prop="alive">
          <el-select
            v-model="filterForm.alive"
            style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option label="在线" value="1"></el-option>
            <el-option label="离线" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          style="width: 1000%;"
          label="代/商/区/门"
          v-if="hasRes('agent_index') || hasRes('user_index') || hasRes('user_area_index') || hasRes('user_store_index')">
          <el-select
            filterable
            default-first-option
            v-model="filterForm.agentid"
            @change="onAgentSelected" >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="`${agent.agentname}（${agent.nickname}）`"
              :value="agent.agentid">
            </el-option>
          </el-select>
          <el-select
            filterable
            default-first-option
            v-model="filterForm.userid"
            @change="onUserSelected"
            v-if="hasRes('user_index')" >
            <el-option label="全部" value=""></el-option>
            <el-option label="未绑定" value="888888"></el-option>
            <el-option
              v-for="user in userList"
              :key="user.userid"
              :label="user.username"
              :value="user.userid">
            </el-option>
          </el-select>
          <el-select
            filterable
            default-first-option
            v-model="filterForm.area"
            @change="onAreaSelected"
            v-if="hasRes('user_area_index')">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="area in areaList"
              :key="area._id"
              :label="area.area_name"
              :value="area._id">
            </el-option>
          </el-select>
          <el-select
            filterable
            default-first-option
            v-model="filterForm.store"
            v-if="hasRes('user_store_index')" >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="store in storeList"
              :key="store._id"
              :label="store.store_name"
              :value="store._id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="resetFilters">重置</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'DevFilterForm',
  data () {
    return {
      filterForm: {
        sn: '',
        clientid: '',
        title: '',
        iccid: '',
        mac_id: '',
        app_code: '',
        alive: '',
        type: '',
        agentid: '',
        userid: '',
        area: '',
        store: ''
      }
    }
  },
  computed: {
    ...mapState('agent', [
      'agentList'
    ]),
    ...mapState('user', [
      'userList',
      'areaList',
      'storeList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('agent', [
      'getAgents'
    ]),
    ...mapActions('user', [
      'getUsers',
      'getAreas',
      'getStores'
    ]),

    // 过滤相关
    onAgentSelected () {
      this.filterForm.user = ''
      this.filterForm.area = ''
      this.filterForm.store = ''
      if (this.hasRes('user_index')) {
        this.getUsers({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid
          }
        })
      }
      if (this.hasRes('user_area_index')) {
        this.getAreas({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_store_index')) {
        this.getStores({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        })
      }
    },
    onUserSelected () {
      this.filterForm.area = ''
      this.filterForm.store = ''
      if (this.hasRes('user_area_index')) {
        this.getAreas({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_store_index')) {
        this.getStores({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        })
      }
    },
    onAreaSelected () {
      this.filterForm.store = ''
      if (this.hasRes('user_store_index')) {
        this.getStores({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        })
      }
    },
    async getSelectDatas () {
      if (this.hasRes('agent_index')) {
        try {
          await this.getAgents({
            page: 1,
            pageSize: 9999
          })
        } catch (err) {
          console.log(err)
        }
      }

      // Get all users, areas, stores for select options
      if (this.hasRes('user_index')) {
        this.getUsers({
          page: 1,
          pageSize: 9999
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_area_index')) {
        this.getAreas({
          page: 1,
          pageSize: 9999
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_store_index')) {
        this.getStores({
          page: 1,
          pageSize: 9999
        }).catch(err => {
          console.log(err)
        })
      }
    },

    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)

      this.$emit('filter')
    },
    resetFilters () {
      this.$refs['filterForm'].resetFields()

      this.filterForm.type = ''
      this.filterForm.agentid = ''
      this.filterForm.userid = ''
      this.filterForm.area = ''
      this.filterForm.store = ''
      this.getSelectDatas()
    }
  },
  mounted () {
    this.getSelectDatas()
    if ('userid' in this.$route.query) {
      this.filterForm.userid = this.$route.query.userid
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.dev-filter-form {

  .filter-wrapper .el-form-item {
    width: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dev/DevFilterForm.vue